import { Box, Stack } from '@mui/material'
import { Container, Typography } from '@evocolabs/orkaui'
import { ContentTitle, SectionTitle } from '@/src/components/title'

import CDN from '@/src/utils/CDN'
import ImageCard from '../ImageCard'
import styles from './styles.module.scss'

const data = {
  title: 'A Hearing Solution Tailor-Made for You',
  cardList: [
    {
      title: `Personalization 1:
    Personalized In-App Hearing Profiles`,
      // eslint-disable-next-line max-len
      content: `Following an in-app hearing screening, Orka Health app tailors your hearing profile, making sure that Orka Two adapts perfectly to your unique hearing conditions.`,
      img: '/website/buy-orka-two/solution_personalization1.jpg'
    },
    {
      title: `Personalization 2:
    Unlimited Remote Adjustments`,
      // eslint-disable-next-line max-len
      content: `Orka's partners provide unlimited consultations with licensed Hearing Care Professionals for onboarding, regular check-ups, and personalized adjustments to ensure optimal hearing care.`,
      img: '/website/buy-orka-two/solution_personalization_2_241212.jpg'
    }
  ]
}

const Card = ({
  img,
  title,
  content
}: {
  img: string
  title: string
  content: string
}) => {
  return (
    <ImageCard src={CDN(img)} title={title} maxWidth="400px">
      <Stack alignItems="center">
        <ContentTitle>{title}</ContentTitle>
        <Typography variant="body1" mt={2} textAlign="center">
          {content}
        </Typography>
      </Stack>
    </ImageCard>
  )
}
const Solution = () => {
  return (
    <Container className={styles.section}>
      <SectionTitle>{data.title}</SectionTitle>
      <Box className={styles.content__solution}>
        {data.cardList.map(({ title, ...restProps }) => (
          <Card title={title} {...restProps} key={title} />
        ))}
      </Box>
    </Container>
  )
}
export default Solution
